var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"partnerLogo hover",attrs:{"href":_vm.url,"target":"_blank"}},[_c('figure',{staticClass:"partnerLogo__image"},[_c('img',{attrs:{"src":_vm.logo,"alt":_vm.name}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230599b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartnerLogo.vue
// module id = null
// module chunks = 